import React, { Component } from 'react';
import Publicnav from "./publicNav.js"
import Publicleft from "./publicleft.js"
import Publicright from "./publicright"
import "./about.css"
// import Public from './public.js';
class About  extends Component {

    constructor(props){
        super(props)  
        this.state ={
            pamaschange : "",
            public : [],
            notification:[],
            noerorrpage :  true,
            image :"https://cf-images.eu-west-1.prod.boltdns.net/v1/static/624246174001/71783484-3712-4c9a-93ea-ca05f4221b31/440d85db-2e69-430d-9776-9c92494250ba/1280x720/match/image.jpg"
        }
    }

   componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
     const { match: { params } } = this.props;
     console.log("params.userId",params.id)
     this.setState({
         pamaschange : params.id
     })

            this.setState({
                noticepop : false,
                loadingnews :true
            })
            console.log("public users id", this.state.pamaschange)
            // console.log("get payment",  Auth.getProfile().userId)
            const requestOptions = {
                method: 'GET', 
                headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
            };
            console.log("public users param", params.id)
            fetch("https://uvunebeta.herokuapp.com/users/"+params.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
                if(result){
                    console.log("public users", result)
                    this.setState({
                        loadingnews :false,
                        public : result
                    })
                }else{
                    this.setState({
                        lloadingnews  :true
                    }) 
                }
            })
            fetch("https://uvunebeta.herokuapp.com/notifications?created_by="+ params.id, requestOptions)
             .then(res => res.json())
             .then((result)=>{
               if(result){
                   console.log("result notification", result.data)
                   this.setState({
                       loadingedit:true,
                       noticeshow : true,
                       notification:result.data
                   })
                  //  this.getData(result)
                  
               }
             }).catch( (error) => {
               //  console.log("errro", error);
                console.log("error load", error )
           });

            
        } 

        
        closenav = (data)=>{
            console.log("data ---===---> ", data)
            this.props.closenav(data)
         }

  
  render() {
    
    return (
            <div className="public-body-container"> 
                <div class="header-me"  >
               
                  <h2>Guangdong</h2>
                 {/* <div style={{backgroundImage: "url(" + this.state.image + ")", "width": "81%",margin:"auto",height:"200px"}} ></div> */}
                 {/* <img src={this.state.image}  /> */}
              </div>
 
              <Publicnav closenav={this.closenav} />
              <div className="public-body-sidevan">
                <ul className="public-body-sidevan-list">
                    <li>
                    <i class="fas fa-comment-alt" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Chat now</p>
                    </li>
                    <li>
                    <i class="fas fa-envelope" style={{fontSize:"210%"}}></i>
                    <br/>
                    <p style={{fontSize:"70%"}}>Leave Messages</p>
                    </li>
                </ul>
             </div>

                <div className="contect-body-page">
                    <div className="contect-body-page-info">
                        <div className="contect-body-page-info-head">
                                    <p>Company Contact Information</p>
                        </div>
                        <div className="contect-body-info-image-info">
                            <div class="columns">
                                <div class="column is-two-fifths">
                                <div className="contect-body-image">
                                    <img src="https://www.seoclerk.com/pics/551103-1TOqFD1502285018.jpg"  />
                                    <h3>
                                    Ms. Zhang Kalinda
                                    </h3>
                                    <i class="fas fa-comment-alt" style={{fontSize:"170%"}}></i>
                                    <p style={{position:"relative",bottom:"10px"}}>chat now</p>
                                </div>
                                </div>
                                <div class="column">
                                    <div className="contect-body-info">
                                    <p><b> Telephone : </b> +123905587467</p>  
                                    <p><b> Address : </b> 	nancheng</p>  
                                    <p><b> Zip: </b> 	889955</p>  
                                    <p><b> Country/Region : </b>	Guangdong</p>  	
                                    </div> 
                                </div>
                                {/* <div class="column">Auto</div> */}
                            </div>
                        </div>
                        
                        
                       
                        
                    </div>
                    <div className="about-body-page-info">
                            <div className="contect-body-page-info-head">
                                Company Contact Information
                            </div> 
                            <div className="about-body-info-image-info">
                                <div className="contect-body-info">
                                    <p><b> Company Name : </b> 	Guangdong</p>  
                                    <p><b> Operational Address : </b> 	6th Floor, Building A, Juda E-Commerce Industry Park, Zhongli Road, Nancheng Area</p>  
                                    <p><b> Website: </b> http://www.topk.com</p>  
                                    <p><b> Website on uvune.com : </b> 	uvune.Guangdong.com</p>  	
                                 </div> 
                            </div>  
                     </div>
                     <div className="publie-content-first-product">
                   <div className="publie-content-title-first">
                     <b> NEW PRODUCT  </b> 
                   </div>

                   <div className="publie-content-image">
                   
                        <ul className="publie-content-image-li"> 
                        <li>
                                    <div className="publie-content-image-sub">
                                            <img src="https://natura.gfl.eu/content/files/images/c_the-natura/thererumnatura_16a.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                                 <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjofqmU_l-G6it6MgPt-1Gu6kfL4YJ7eROMEDBBdh3kN1K7icI" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNzr-s9CPS69u5QDqsRmE20oPmkWT34Oz1CpHI9OpXQWmJbkwevA" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                             
                            </li>
                            <li>
                            <div className="publie-content-image-sub">
                                            <img src="https://cdn11.bigcommerce.com/s-u6pyv0n7lf/content/home/tea-tree-special-shampoo-feature-banner-sep17-2.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                                 
                               
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDzzfyfvAHv5OhLwCQ1tIkRQBRdBNnIrPkkcHTrYrjQ2s5KKsM" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://d1ebdenobygu5e.cloudfront.net/media/catalog/product/cache/thumbnail/300x300/beff4985b56e3afdbeabfc89641a4582/h/g/hgc-front.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://www.henkel.com/resource/image/199864/4x3/335/251/f213e247ccf8ef662fac50da01079af4/ap/product-assortment-adhesives.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>

                            <li>
                            
                            <div className="publie-content-image-sub">
                                            <img src="https://www.charlottesweb.com/media/catalog/product/cache/1/small_image/480x/9df78eab33525d08d6e5fb8d27136e95/c/b/cbd-oil-max-strength.jpg" /> 
                                    </div>
                                    <div className="publie-content-item-name">
                                        Free Shipping TOPK AM60 1M 18W QC 3.0 Magnetic USB Cable
                                        <h3>$2.69 - $3.99</h3>
                                        <a class="button is-link is-rounded">Rounded</a>
                                    </div>
                            </li>
                            
                           
                        </ul>
                   </div>

                </div>
                      
                    <div className="publie-content-fooler-body">
                    <div class="content has-text-centered">
                                    <p>
                                    <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
                                    <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
                                    is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
                                    </p>
                         </div>

                    </div>
                    
                </div>
                      
                 {/* <Publicleft name={this.state.public.display_name} image={this.state.public.image_url} address={this.state.public.address} />   */}
                     
                      
                      
              

           </div>     

    )

}





}

export default About;


// WEBPACK FOOTER //
// ./src/component/public/about.js